import { Children, Component } from 'react'
import PropTypes from 'prop-types'

import { Type, read } from '@acorns/web-utils'
import axios from 'axios'
import * as _ from 'lodash'
import { compose, getContext, lifecycle } from 'recompose'
import UAParser from 'ua-parser-js'

export class BackendProvider extends Component<{ appId: string; backend: any }, any> {
  public static propTypes = {
    appId: PropTypes.string.isRequired,
    backend: PropTypes.any.isRequired,
  }

  public static childContextTypes = {
    appId: PropTypes.string.isRequired,
    backend: PropTypes.any.isRequired,
  }

  public getChildContext() {
    const { appId, backend } = this.props

    return { appId, backend }
  }

  public render() {
    return Children.only(this.props.children)
  }
}

export const withBackend = compose(
  getContext({
    appId: PropTypes.string,
    backend: PropTypes.any,
  }),
  lifecycle<any, {}>({
    componentDidMount() {
      if (this.props.backend) {
        const userAgentParser = new UAParser()
        const userAgent = userAgentParser.getResult()
        const release = this.props.env ? this.props.env.get('release') : ''

        if (_.get(this.props, 'backend.defaults.headers.common', false)) {
          this.props.backend.defaults.headers.common = {
            ...this.props.backend.defaults.headers.common,
            'X-Client-App': this.props.appId,
            'X-Client-Browser': userAgent.browser.name,
            'X-Client-Browser-Version': userAgent.browser.version,
            'X-Client-Build': release,
            'X-Client-Hardware': userAgent.device.model,
            'X-Client-Os': userAgent.os.name,
            'X-Client-Platform': 'web',
          }
        }
      }
    },
  }),
)

export default url => {
  const backend = axios.create({
    baseURL: url,
  })

  backend.interceptors.request.use(
    config => {
      const token = read(Type.token)

      return {
        ...config,
        headers: {
          ...config.headers,
          Authorization: `token ${token}`,
        },
      }
    },
    error => Promise.reject(error),
  )

  return backend
}
